import type { WrpfEntryAnchor, WrpfRealtimeConfig, WrpfSessionState, WrpfSponsor } from "./types";

/** Forma del callback del bundle que necesita la sesión (subset de WrpfCallbackMeta). */
type HandoffCallback = {
  resultsUrl: string;
  token: string;
  expiresAt: string;
  syncUrl?: string;
  realtime?: WrpfRealtimeConfig | null;
} | null;

export type WrpfSessionAction =
  | {
      type: "SET_WRPF_SESSION";
      session: WrpfSessionState;
    }
  | {
      type: "UPDATE_WRPF_TOKEN";
      callbackToken: string;
      tokenExpiresAt: string;
      callbackUrl: string;
    }
  | {
      type: "SET_WRPF_LAST_DOWNLOADED";
      at: string;
    }
  | {
      type: "SET_WRPF_LAST_PUBLISHED";
      at: string;
    };

export const defaultWrpfSessionState = (): WrpfSessionState => ({
  tournamentId: null,
  callbackUrl: null,
  callbackToken: null,
  tokenExpiresAt: null,
  handoffBundleUrl: null,
  syncUrl: null,
  realtime: null,
  entryAnchors: [],
  sponsors: [],
  lastResultsPublishedAt: null,
  lastDownloadedAt: null,
});

export const setWrpfSession = (session: WrpfSessionState): WrpfSessionAction => ({
  type: "SET_WRPF_SESSION",
  session,
});

export const updateWrpfToken = (params: {
  callbackToken: string;
  tokenExpiresAt: string;
  callbackUrl: string;
}): WrpfSessionAction => ({
  type: "UPDATE_WRPF_TOKEN",
  ...params,
});

export const setWrpfLastDownloaded = (at: string): WrpfSessionAction => ({
  type: "SET_WRPF_LAST_DOWNLOADED",
  at,
});

export const setWrpfLastPublished = (at: string): WrpfSessionAction => ({
  type: "SET_WRPF_LAST_PUBLISHED",
  at,
});

export function sessionFromBundleMeta(wrpf: {
  tournamentId: string;
  callback: HandoffCallback;
  entryAnchors: WrpfEntryAnchor[];
  sponsors?: WrpfSponsor[];
}): WrpfSessionState {
  return {
    tournamentId: wrpf.tournamentId,
    callbackUrl: wrpf.callback?.resultsUrl ?? null,
    callbackToken: wrpf.callback?.token ?? null,
    tokenExpiresAt: wrpf.callback?.expiresAt ?? null,
    handoffBundleUrl: null,
    syncUrl: wrpf.callback?.syncUrl ?? null,
    realtime: wrpf.callback?.realtime ?? null,
    entryAnchors: wrpf.entryAnchors,
    sponsors: wrpf.sponsors ?? [],
    lastResultsPublishedAt: null,
    lastDownloadedAt: null,
  };
}

export function sessionFromWrpfHandoff(
  wrpf: {
    tournamentId: string;
    callback: HandoffCallback;
    entryAnchors: WrpfEntryAnchor[];
    sponsors?: WrpfSponsor[];
  },
  bundleUrl: string,
  handoffToken: string,
): WrpfSessionState {
  const base = sessionFromBundleMeta(wrpf);
  return {
    ...base,
    handoffBundleUrl: bundleUrl,
    callbackToken: handoffToken,
    callbackUrl: wrpf.callback?.resultsUrl ?? null,
    tokenExpiresAt: wrpf.callback?.expiresAt ?? null,
  };
}
